// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"36abd298","455":"34b07621","643":"0e02bb73","734":"a484f421","967":"083a1046"}[chunkId] + ".chunk.js";
};